import React from 'react';
import { Box, Stack } from '@mui/material';
import Modal from '@mui/material/Modal';
import { NormalText } from 'components/styled/text.styled';
import { Button } from '@mui/material';

interface Props {
  open: boolean;
  handleClose?: () => void;
  description?: string;
  title?: string;
  confirmText?: string;
  cancelText?: string;
  titleStyle?: React.CSSProperties;
  descriptionStyle?: React.CSSProperties;
  handleConfirm: () => void;
  deleteRow?: any;
  isCategory?: boolean;
  isBrand?: boolean;
  isVariant?: boolean;
  isVariantOption?: boolean;
  isUserWithMerchant?: boolean;
  isMerchantWithAdmins?: boolean;
  detailData?: any;
}

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  borderRadius: '10px',
  boxShadow: 24,
  p: 4,
  textAlign: 'center',
};

const ConfirmationModal = ({
  open,
  handleClose,
  title,
  description,
  confirmText,
  cancelText,
  titleStyle,
  descriptionStyle,
  handleConfirm,
  deleteRow,
  isCategory,
  isBrand,
  isVariant,
  isVariantOption,
  isUserWithMerchant,
  isMerchantWithAdmins,
  detailData,
}: Props) => {
  let dynamicDescription = description ?? 'Yakin ingin menghapus?';
  let isDisabled = false;

  if (isCategory && deleteRow) {
    const { total_product, is_active } = deleteRow;
    if (total_product && total_product > 0) {
      dynamicDescription = 'Kategori ini sedang digunakan, tidak dapat dihapus';
      isDisabled = true;
    } else if (is_active === true) {
      dynamicDescription =
        'Kategori ini dalam kondisi aktif, silahkan non-aktifkan untuk menghapus';
      isDisabled = true;
    } else {
      dynamicDescription = 'Apakah kamu yakin menghapus kategori ini?';
      isDisabled = false;
    }
  } else if (isBrand && deleteRow && detailData) {
    const { total_product, status } = detailData;
    if (total_product && total_product > 0) {
      dynamicDescription = 'Merek ini sedang digunakan, tidak dapat dihapus';
      isDisabled = true;
    } else if (status === true) {
      dynamicDescription = 'Merek ini dalam kondisi aktif, silahkan non-aktifkan untuk menghapus';
      isDisabled = true;
    } else {
      dynamicDescription = 'Yakin ingin menghapus brand ini?';
      isDisabled = false;
    }
  } else if (isUserWithMerchant) {
    dynamicDescription = 'User ini berada di dalam Merchant, tidak dapat dihapus';
    isDisabled = true;
  } else if (
    isMerchantWithAdmins &&
    detailData &&
    detailData.admins &&
    detailData.admins.length > 0
  ) {
    dynamicDescription = 'Merchant ini ada User yang ter-assign, tidak dapat dihapus.';
    isDisabled = true;
  } else if (isVariantOption && deleteRow) {
    const { isActive, is_active } = deleteRow;
    const currentStatus = isActive !== undefined ? isActive : is_active;

    if (currentStatus === true) {
      dynamicDescription =
        'Opsi Atribut ini sedang dalam kondisi aktif, nonaktifkan sebelum menghapusnya';
      isDisabled = true;
    } else {
      dynamicDescription = 'Apakah kamu yakin menghapus Opsi Atribut ini?';
      isDisabled = false;
    }
  } else if (isVariant && deleteRow) {
    const { isActive } = deleteRow;
    if (isActive === true) {
      dynamicDescription =
        'Atribut ini sedang dalam kondisi aktif, nonaktifkan varian sebelum menghapusnya';
      isDisabled = true;
    } else {
      dynamicDescription = 'Apakah kamu yakin menghapus atribut ini?';
      isDisabled = false;
    }
  }

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-description"
      aria-describedby="modal-modal-description"
      sx={{ zIndex: '100000' }}
    >
      <Box sx={style}>
        {title && <NormalText style={titleStyle}>{title ?? 'Konfirmasi'}</NormalText>}
        <NormalText style={{ ...descriptionStyle, color: isDisabled ? 'red' : 'inherit' }}>
          {dynamicDescription}
        </NormalText>
        <Stack direction={'row'} spacing={1} margin={'10px 0 0 0'} justifyContent={'center'}>
          <Button
            variant="contained"
            onClick={handleConfirm}
            disabled={isDisabled}
            style={{
              opacity: isDisabled ? 0.5 : 1,
              cursor: isDisabled ? 'not-allowed' : 'pointer',
              width: '80px',
            }}
          >
            {confirmText ?? 'Yes'}
          </Button>
          <Button 
            variant="outlined" 
            onClick={handleClose}
            style={{ width: '80px' }}
          >
            {cancelText ?? 'No'}
          </Button>
        </Stack>
      </Box>
    </Modal>
  );
};

export default ConfirmationModal;
